import { PolicyContainer } from './styled';
import PolicyA from '../Overview/PolicyA/Apolicy';

export default function index() {
  return (
    <>
      <PolicyContainer>
        <h3 className="term">Privacy Policy for Mylo</h3>
        <div>
          <PolicyA />
        </div>
      </PolicyContainer>
    </>
  );
}
